'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  hasIcon: _propTypes2.default.bool,
  isBounded: _propTypes2.default.bool
};
var defaultProps = {
  hasIcon: false,
  isBounded: false
};

var padding = function padding(_ref) {
  var hasIcon = _ref.hasIcon,
      isRemovable = _ref.isRemovable,
      themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.tag;
  var _path$content = path.content,
      paddingY = _path$content.paddingY,
      paddingX = _path$content.paddingX,
      iconTextOffset = _path$content.iconTextOffset;
  return (0, _styledComponents.css)(['padding:', ' ', ';', ' ', ''], (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX), hasIcon && 'padding-left: ' + (0, _reactackleCore.getValueString)(iconTextOffset) + ';', isRemovable && '\n      padding-right: ' + (0, _reactackleCore.getValueString)(path.removeIcon.iconTextSpacing) + ';\n    ');
};

var isBounded = function isBounded(_ref2) {
  var isBounded = _ref2.isBounded;
  return isBounded && '\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n';
};

var ContentStyled = exports.ContentStyled = _styledComponents2.default.span.withConfig({
  displayName: 'ContentStyled'
})(['', ' ', ''], padding, isBounded);

ContentStyled.propTypes = propTypes;
ContentStyled.defaultProps = defaultProps;